import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import Loading from "../Loading";

type Props = {
  requiredGroups?: string[];
  children?: React.ReactNode;
};

const SignedOutRoute: React.FC<Props> = ({ children }) => {
  const auth = getAuth();
  const [user, loading, error] = useAuthState(auth);

  if (loading) {
    return (
      <div className="flex h-dvh w-full items-center justify-center">
        <Loading size="lg" />
      </div>
    );
  }

  if (error) return <Navigate to="/error" />;

  if (user) return <Navigate to="/events" />;

  return <>{children}</>;
};

export default SignedOutRoute;
